import { toast, Bounce, ToastPosition, ToastTransition } from 'react-toastify'

export const useCreateToast = () => {
  const createSuccessToast = (toastMessage: string, position?: ToastPosition, transition?: ToastTransition) =>
    toast.success(toastMessage, {
      position: position? position : 'bottom-center',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: 'light',
      transition: transition ? transition : Bounce,
    })

  const createInfoToast = (toastMessage: string, position?: ToastPosition, transition?: ToastTransition) =>
    toast.info(toastMessage, {
      position: position? position : 'bottom-center',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: 'light',
      transition: transition ? transition : Bounce,
    })

  const createWarningToast = (toastMessage: string, position?: ToastPosition, transition?: ToastTransition) =>
    toast.warning(toastMessage, {
      position: position? position : 'bottom-center',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: 'light',
      transition: transition ? transition : Bounce,
    })

  const createErrorToast = (toastMessage: string, position?: ToastPosition, transition?: ToastTransition) =>
    toast.error(toastMessage, {
      position: position? position : 'bottom-center',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: 'light',
      transition: transition ? transition : Bounce,
    })

  return { createSuccessToast, createInfoToast, createWarningToast, createErrorToast }
}
